module.exports = __webpack_public_path__ + "img/zhuye_logo.e11cd5f3.png";